import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, useBreakpoint, View} from "shared/base"
import {Pressable, StyleSheet} from "react-native"
import React, {useMemo} from "react"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import {WithDefaultStyle} from "@kaspernj/api-maker/build/utils/default-style"

const styles = StyleSheet.create({
  root: {
    backgroundColor: "#fff",
    borderRadius: 48,
    padding: 32
  },
  rootActive: {
    backgroundColor: "#5253ff"
  },
  rootLarge: {
    padding: 48
  },
  textBlue: {
    color: "#2c2c96"
  },
  textWhite: {
    color: "#fff"
  },
  veryLarge: {
    padding: 56,
    borderRadius: 80
  }
})

/**
 * @typedef {object} ComponentsChalkyLayoutCardProps
 * @property {boolean} active
 * @property {unknown} children
 * @property {unknown} dataSet
 * @property {boolean} large
 * @property {unknown} onClose
 * @property {unknown} style
 * @property {unknown} testID
 * @property {boolean} veryLarge
 */

/** @typedef {object} ComponentsChalkyLayoutCardState */

/**
 * @extends {ShapeComponent<ComponentsChalkyLayoutCardProps, ComponentsChalkyLayoutCardState>}
 */
class ComponentsChalkyLayoutCard extends ShapeComponent {
  static defaultProps = {
    active: false,
    dataSet: null,
    large: false,
    onClose: null,
    style: null,
    veryLarge: false
  }

  static propTypes = propTypesExact({
    active: PropTypes.bool.isRequired,
    children: PropTypes.node,
    dataSet: PropTypes.object,
    large: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    style: PropTypes.object,
    testID: PropTypes.string,
    veryLarge: PropTypes.bool.isRequired
  })

  setup() {
    this.breakpoint = useBreakpoint()
    this.xsUp = this.breakpoint.xsUp
    this.xsDown = this.breakpoint.xsDown
    this.smUp = this.breakpoint.smUp
    this.smDown = this.breakpoint.smDown
    this.mdUp = this.breakpoint.mdUp
    this.mdDown = this.breakpoint.mdDown
    this.lgUp = this.breakpoint.lgUp
    this.lgDown = this.breakpoint.lgDown
    this.xlUp = this.breakpoint.xlUp
    this.xlDown = this.breakpoint.xlDown
    this.xxlUp = this.breakpoint.xxlUp
    this.xxlDown = this.breakpoint.xxlDown
    this.windowWidth = this.breakpoint.windowWidth
    this.windowHeight = this.breakpoint.windowHeight
  }

  render() {
    const {mdUp} = this.tt
    const {active, children, dataSet, onClose, style, veryLarge} = this.p
    const {testID} = this.props
    const rootStyles = useMemo(
      () => {
        const rootStyles = [styles.root]

        if (active) rootStyles.push(styles.rootActive)
        if (mdUp) rootStyles.push(styles.rootLarge)
        if (style) rootStyles.push(style)
        if (veryLarge) rootStyles.push(styles.veryLarge)

        return rootStyles
      },
      [active, mdUp, style, veryLarge]
    )

    const defaultStyle = useMemo(
      () => {
        if (active) {
          return {Text: [styles.textWhite]}
        } else {
          return {Text: [styles.textBlue]}
        }
      },
      [active]
    )

    const actualDataSet = useMemo(() =>
      Object.assign(
        {class: "chalky-layout/card"},
        dataSet
      )
    , [])

    return (
      <View dataSet={actualDataSet} style={rootStyles} testID={testID}>
        <WithDefaultStyle style={defaultStyle}>
          <View>
            <View>
              {children}
            </View>
            {onClose &&
              <Pressable onPress={onClose} style={this.closePressableStyle ||= {position: "absolute", right: 0}}>
                <Icon name="remove" size={20} />
              </Pressable>
            }
          </View>
        </WithDefaultStyle>
      </View>
    )
  }
}

export default memo(shapeComponent(ComponentsChalkyLayoutCard))
